import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "../../../environments/environment";

@Injectable()
export class ManageDiseasesService {

    url: any = environment.API_URL;


    constructor(
        private http: HttpClient
    ) {

    }

    getInterests(data: any) {
        return this.http.post(this.url + 'category/list', data);
    }

    createInterests(data: any) {
        return this.http.post(this.url + 'api/sports/create', data);
    }

    updateInterest(data: any) {
        return this.http.patch(this.url + 'category/update', data);
    }

    getSportsList(page: number, pageLimit: number) {
        const data = {
          page: page,
          pageLimit: pageLimit,
        };
      
        return this.http.post(this.url + 'api/sports/list', data);
      }

      deleteSports(id: string) {
        const httpOptions = {
          headers: new HttpHeaders({}),
        };
        return this.http.delete(`${this.url}api/sports/delete/${id}`, httpOptions);
      }
      

    deleteInterest(data: any) {
        const httpOptions = {
            headers: new HttpHeaders({}), body: data
        };
        return this.http.delete(this.url + 'category/delete', httpOptions);
    }

    importInterest(data: any) {
        return this.http.post(this.url + 'import/areaOfInterest', data);
    }



   

    
    deleteCategory(data:any){

        const httpOptions = {
            headers: new HttpHeaders({}), body: data
        };
        return this.http.delete(this.url + 'admin/category/delete',httpOptions);
    }

   

    editCategory(data:any){
        return this.http.post(this.url + 'api/sports/edit', data);
    }

    getCategoryapi(data:any) {
        return this.http.post(this.url + 'admin/category/get', data);
    }


   
    uploadImage(data:any){
        return this.http.post(this.url + 'api/user/upload', data);
    }
    
   

    deleteDisease(data:any){
      
        return this.http.post(this.url + 'disease/delete', data);
    }

    diseaseEdit(data:any){
        return this.http.post(this.url + 'disease/edit', data);
    }
    
}